import React, { useEffect, useState } from "react";
import { Form, NumberInput } from "react-admin";
import { Grid, Typography, Box, CircularProgress } from "@mui/material";
import { candidateRequests } from "api/candidateApi";
import dataProvider from "server/dataProvider";
import { useNotifyError } from "utils/useNotifyError";

const SchoolGradesForm = ({ candidacyId, userId, initialGrades, onGradesChange }) => {
  const notifyError = useNotifyError();

  const [subjects, setSubjects] = useState([]);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [subjectsRes, gradesRes] = await Promise.all([
          dataProvider.customRequest(candidateRequests.getSchoolSubjectsByCandidacy(candidacyId), null, "GET"),
          dataProvider.customRequest(candidateRequests.userSchoolSubjectGrades(userId), null, "GET"),
        ]);

        setSubjects(subjectsRes.data || []);

        const gradesMap = gradesRes.data?.reduce((acc, item) => {
          acc[item.schoolSubjectId] = item.grade;
          return acc;
        }, {});

        onGradesChange(gradesMap || {});
      } catch (error) {
        notifyError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [candidacyId, userId, onGradesChange, notifyError]);

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        my={4}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Form>
      <Grid
        container
        spacing={3}
        sx={{ display: "flex", flex: 1, alignItems: "end" }}
      >
        {subjects.map(sj => (
          <Grid
            key={sj.id}
            item
            xs={12}
            md={4}
            sm={4}
          >
            <Typography
              color="primary"
              variant="body1"
            >
              {sj.nameBg}
            </Typography>
            <NumberInput
              source={sj.id.toString()}
              label="Оценка"
              min={2}
              max={6}
              step={0.01}
              onChange={e => {
                const value = e.target.value;
                // Use the callback prop to update the parent's state
                onGradesChange(prev => ({
                  ...prev,
                  [sj.id]: value === "" ? null : parseFloat(value),
                }));
              }}
              defaultValue={initialGrades[sj.id] ?? ""}
            />
          </Grid>
        ))}
      </Grid>
    </Form>
  );
};

export default SchoolGradesForm;
